import * as React from 'react';

import ConfirmDialog from 'components/ConfirmDialog';
// @ts-ignore
import GroupActions from 'groups/actions/GroupActions';
// @ts-ignore
import Group from 'entities/Group';

import ToastActions from 'actions/ToastActions';

type Props = {
  group: Group;
  onActionCompletion: Function;
  onRequestHide?: () => any;
};

export default class RemoveClassConfirmDialog extends React.Component<Props> {
  onSuccess = (group: Group) => {
    ToastActions.showSuccessToast('Class archived');
    this.props.onActionCompletion(group);
  };
  onError = (error: { message: string }) => {
    ToastActions.showErrorToast(error.message);
  };
  handleRemove = (): Promise<any> => {
    const { group } = this.props;

    return GroupActions.archiveGroup(group).then(this.onSuccess, this.onError);
  };

  render() {
    return (
      <ConfirmDialog
        eventScreenName="RemoveClassConfirmDialog"
        title="Remove this class from your list?"
        subtext={
          'This class will be archived, but you can always view and restore it from your settings.'
        }
        actionButtonText="Remove"
        cancelButtonText="Cancel"
        onRequestHide={this.props.onRequestHide}
        preConfirmPromise={this.handleRemove}
      />
    );
  }
}
